module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('Form', [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('PEIXUNBANJI')
    }
  }, [_vm._v(_vm._s(_vm.item.name))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SHIJIANFANWEI')
    }
  }, [_vm._v(_vm._s(_vm.item.beginTime) + "-" + _vm._s(_vm.item.endTime))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('BANJIBIANHAO')
    }
  }, [_vm._v(_vm._s(_vm.item.subtitle))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SUOSHUZUZHI')
    }
  }, [_vm._v(_vm._s(_vm.item.domainName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('GUANLIWEIDU')
    }
  }, [_vm._v(_vm._s(_vm.item.dimensionNames))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SHISHIBUMEN')
    }
  }, [_vm._v(_vm._s(_vm.item.orgName))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('PEIXUNDIDIAN')
    }
  }, [_vm._v(_vm._s(_vm.item.trainAddress))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KESHI')
    }
  }, [_vm._v(_vm._s(_vm.item.sumClassHour))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('XUEFEN')
    }
  }, [_vm._v(_vm._s(_vm.item.sumClassCredit))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fa34630"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/shared/views/trainClassAudit.vue
// module id = 924
// module chunks = 80